import { Navigate } from "react-router";

import { useWeb3ModalAccount } from "@web3modal/ethers/react";

const UserRoute = ({ children }) => {
  const { isConnected } = useWeb3ModalAccount()
  const role = isConnected || undefined;
  return role ? children : <Navigate to="/" />;
};

export default UserRoute;